import { Route, Routes } from 'react-router';
import AppRoutes, { AppRoutes2, ArrayRoutes } from './AppRoutes';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/AuthCompnents/RequireAuth';
import { Login } from './components/AuthCompnents/Login';
import { PersistLogin } from './components/AuthCompnents/PersistLogin';

enum ROLES {
    ADMIN = "Administrador",
    PROSP = "Prospectador",
    VEN = "Vendedor",
}

export function App() {
    return (
        <Routes>
            <Route path="/not-found" element={<div>404 Página no encontrada</div>}/>
            <Route path="/login" element={<Login />}/>

            <Route path="/" element={<Layout />}>

                <Route element={<PersistLogin />}>

                    {/* <Route element={<RequireAuth allowedRoles={[ROLES.ADMIN, ROLES.PROSP]} />}>
                        {AppRoutes.map((route, index) => {
                        const { element, ...rest } = route;
                        return <Route key={index} path={route.path} element={element}/>;
                        })}
                    </Route> */}

                    <Route element={<RequireAuth allowedRoles={[ROLES.ADMIN, ROLES.PROSP]} />}>
                        {ArrayRoutes.map((route, index) => (
                        <Route path={route.home.path} >
                            <Route index={true} key={index} element={route.home.element}/>
                            {route.nested.map((route, index) => (
                                <Route key={index} path={route.path} element={route.element}/>
                            ))}
                        </Route>
                        ))}
                    </Route>

                    <Route element={<RequireAuth allowedRoles={[ROLES.ADMIN]} />}>
                        <Route path={AppRoutes2.panel.home.path} element={AppRoutes2.panel.home.element}/>;
                    </Route>

                </Route>

            </Route>

        </Routes>
    );
}